import { Card, CardBody, CardHeader } from 'reactstrap'
import CreateJobInput from './CreateJobInput'
import Footer from './Footer'
import { useEffect, useState } from 'react'
import AxiosInstance from 'utils/AxiosInstance'
import { useDispatch } from 'react-redux'
import { setJobProp } from 'store/Recruitment/actions'
import { useSelector } from 'react-redux'
import { fetchAllStores } from 'store/Stores/actions'
import { getSkills } from 'store/Recruitment/actions'
import { createSkill } from 'store/Recruitment/actions'

import './styles.css'

const statusOptions = [
  { name: 'Active', value: 'active' },
  { name: 'Inactive', value: 'inactive' },
]

const jobTypeOptions = [
  { name: 'Full Time', value: 'fullTime' },
  { name: 'Part Time', value: 'partTime' },
]

const recruitmentTypeOptions = [
  { name: 'Internal', value: 'internal' },
  { name: 'External', value: 'external' },
]

function FirstSlide() {
  const dispatch = useDispatch()

  const { jobProps } = useSelector((store) => store.recruitment)
  const { allStores } = useSelector((store) => store.stores)

  const { skills } = useSelector((store) => store.recruitment)

  const [jobCategories, setJobCategories] = useState([])

  useEffect(() => {
    AxiosInstance.get(`/recruitment/setup/job_categories`).then((data) => {
      setJobCategories(
        data.map((el) => {
          return { name: el.value, value: el.value, id: el.id }
        })
      )
    })
  }, [])

  useEffect(() => {
    dispatch(getSkills())
    dispatch(fetchAllStores())
  }, [dispatch])

  return (
    <div className='create-job-form-container'>
      <Card>
        <CardHeader className='d-flex align-items-center'>
          <p className='title w-50'>Job Details</p>
          <p className='title w-50 ml-5 category-details-title'>
            Category Details
          </p>
        </CardHeader>
        <CardBody>
          <form>
            <div className='align-items-start category-job-details-container'>
              <div
                className='flex-wrap job-details'
                style={{ gap: '0rem 1rem' }}
              >
                <CreateJobInput
                  id='jobTitle'
                  name='title'
                  placeholder='Enter job title'
                  label='Job Title'
                  required={true}
                  fullSize={false}
                  onChange={(val, _, name) =>
                    dispatch(setJobProp({ value: val, name }))
                  }
                  defaultValue={
                    jobProps?.find((el) => el?.name === 'title')?.value
                  }
                />
                <CreateJobInput
                  id='status'
                  name='status'
                  placeholder='Select Status'
                  label='Status'
                  required={true}
                  select={true}
                  fullSize={false}
                  options={statusOptions}
                  onChange={(val, name) =>
                    dispatch(setJobProp({ value: val?.option?.value, name }))
                  }
                  selectedOptions={statusOptions?.find(
                    (option) =>
                      option?.value ===
                      jobProps?.find((el) => el?.name === 'status')?.value
                  )}
                />
                <CreateJobInput
                  id='jobLocation'
                  placeholder='Enter job Location'
                  name='location'
                  label='Location'
                  required={true}
                  fullSize={false}
                  onChange={(val, _, name) =>
                    dispatch(setJobProp({ value: val, name }))
                  }
                  defaultValue={
                    jobProps?.find((el) => el?.name === 'location')?.value
                  }
                />
                <CreateJobInput
                  id='noPositions'
                  placeholder='Enter Position'
                  name='positions'
                  label='No. of Positions'
                  required={true}
                  fullSize={false}
                  type='number'
                  onChange={(val, _, name) =>
                    dispatch(setJobProp({ value: val, name }))
                  }
                  defaultValue={
                    jobProps?.find((el) => el?.name === 'positions')?.value
                  }
                />
                <CreateJobInput
                  id='salaryFrom'
                  name='salary_from'
                  label='Salary From'
                  placeholder='Enter Amount'
                  required={true}
                  fullSize={false}
                  type='number'
                  onChange={(val, _, name) =>
                    dispatch(setJobProp({ value: val, name }))
                  }
                  defaultValue={
                    jobProps?.find((el) => el?.name === 'salary_from')?.value
                  }
                />
                <CreateJobInput
                  id='salaryTo'
                  label='Salary To'
                  name='salary_to'
                  placeholder='Enter Amount'
                  required={true}
                  fullSize={false}
                  type='number'
                  onChange={(val, _, name) =>
                    dispatch(setJobProp({ value: val, name }))
                  }
                  defaultValue={
                    jobProps?.find((el) => el?.name === 'salary_to')?.value
                  }
                />
                <CreateJobInput
                  id='startDate'
                  name='start_date'
                  label='Start Date'
                  required={true}
                  fullSize={false}
                  type='date'
                  onChange={(val, _, name) =>
                    dispatch(setJobProp({ value: val, name }))
                  }
                  defaultValue={
                    jobProps?.find((el) => el?.name === 'start_date')?.value
                  }
                />
                <CreateJobInput
                  id='endDate'
                  label='End Date'
                  name='end_date'
                  required={true}
                  fullSize={false}
                  type='date'
                  onChange={(val, _, name) =>
                    dispatch(setJobProp({ value: val, name }))
                  }
                  defaultValue={
                    jobProps?.find((el) => el?.name === 'end_date')?.value
                  }
                />
                <CreateJobInput
                  id='address'
                  label='Address'
                  name='address'
                  placeholder='Enter Address'
                  fullSize={true}
                  type='textarea'
                  onChange={(val, _, name) =>
                    dispatch(setJobProp({ value: val, name }))
                  }
                  defaultValue={
                    jobProps?.find((el) => el?.name === 'address')?.value
                  }
                />
              </div>
              <div
                className='flex-wrap category-details'
                style={{ gap: '0rem 1rem' }}
              >
                <CardHeader className='align-items-center category-header-second'>
                  <p className='title w-50 category-details-second'>
                    Category Details
                  </p>
                </CardHeader>
                <CreateJobInput
                  id='jobType'
                  name='job_type'
                  placeholder='Select Job Type'
                  label='Job Type'
                  required={true}
                  select={true}
                  options={jobTypeOptions}
                  fullSize={false}
                  onChange={(val, name) =>
                    dispatch(setJobProp({ value: val?.option?.value, name }))
                  }
                  selectedOptions={jobTypeOptions?.find(
                    (option) =>
                      option?.value ===
                      jobProps?.find((el) => el?.name === 'job_type')?.value
                  )}
                />
                <CreateJobInput
                  id='jobCategory'
                  name='category_id'
                  placeholder='Select Job Category'
                  label='Job Category'
                  required={true}
                  select={true}
                  options={jobCategories}
                  fullSize={false}
                  onChange={(val, name) =>
                    dispatch(setJobProp({ value: val?.option?.id, name }))
                  }
                  selectedOptions={jobCategories?.find(
                    (el) =>
                      el.id ===
                      jobProps?.find((el) => el?.name === 'category_id')?.value
                  )}
                />
                <CreateJobInput
                  id='recruitmentType'
                  name='recruitment_type'
                  placeholder='Select Recruitment Type'
                  label='Recruitment Type'
                  required={true}
                  select={true}
                  options={recruitmentTypeOptions}
                  fullSize={false}
                  onChange={(val, name) =>
                    dispatch(setJobProp({ value: val?.option?.value, name }))
                  }
                  selectedOptions={recruitmentTypeOptions?.find(
                    (option) =>
                      option?.value ===
                      jobProps?.find((el) => el?.name === 'recruitment_type')
                        ?.value
                  )}
                />
                <CreateJobInput
                  id='branch'
                  name='branch'
                  placeholder='Select Branch'
                  label='Branch'
                  required={true}
                  select={true}
                  options={allStores}
                  fullSize={false}
                  onChange={(val, name) =>
                    dispatch(setJobProp({ value: val?.option?.id, name }))
                  }
                  selectedOptions={allStores?.find(
                    (store) =>
                      store?.id ===
                      jobProps?.find((el) => el?.name === 'branch')?.value
                  )}
                />
                <CreateJobInput
                  id='jobLink'
                  label='Job Link'
                  name='job_link'
                  defaultValue={`${window.location.origin}/career`}
                  required={true}
                  fullSize={true}
                  disabled={true}
                />
                <CreateJobInput
                  id='skillBox'
                  name='skills'
                  label='Skill Box'
                  placeholder='Select or create skills'
                  required={true}
                  fullSize={true}
                  select={true}
                  creatable={true}
                  options={skills}
                  selectedOptions={
                    jobProps?.find((el) => el?.name === 'skills')?.value || []
                  }
                  onChange={(val, name) => {
                    dispatch(setJobProp({ value: val, name }))
                  }}
                  isMulti={true}
                  customClassName='skill-box-dropdown'
                  createFn={(val) =>
                    dispatch(
                      createSkill(val, (newOption) => {
                        const existing =
                          jobProps?.find((el) => el?.name === 'skills')
                            ?.value || []

                        const finalNewOption = {
                          name: newOption.value,
                          id: newOption.value,
                          option: { name: newOption.value },
                        }

                        dispatch(
                          setJobProp({
                            name: 'skills',
                            value: [...existing, finalNewOption],
                          })
                        )
                      })
                    )
                  }
                />
              </div>
            </div>
          </form>
        </CardBody>
        <Footer />
      </Card>
    </div>
  )
}

export default FirstSlide
